import { animate, inView } from "motion";
import { prefersReducedMotion } from "../../Shared/Utilities/userPreferences";

const rotateInFromRight = {
  transform: ["translateX(100%) rotate(15deg)", "translateX(0) rotate(0deg)"],
  opacity: [0, 1]
};

const rotateInFromLeft = {
  transform: ["translateX(-100%) rotate(-15deg)", "translateX(0) rotate(0deg)"],
  opacity: [0, 1]
};

const animationOptions = {
  duration: 0.8,
  easing: "ease-out"
};

function removeAnimationStyles(element: HTMLElement, stop: VoidFunction) {
  setTimeout(() => {
    element.style.removeProperty("transform");
    element.style.removeProperty("opacity");
    stop();
  }, 0);
}

/**
 * Sets up the animation right away, but does not play it until the element is scrolled into view.
 */
const animateInWhenVisible = (
  element: HTMLElement,
  keyframes: { transform: string[]; opacity: number[] },
  onDone: VoidFunction
) => {
  const animation = animate(element, keyframes, {
    ...animationOptions,
    autoplay: false,
    onComplete: () => {
      removeAnimationStyles(element, stop);
      onDone();
    }
  });

  // The element itself is moved out of its place, which would keep it from counting as being in view,
  // so its parent is what is watched
  const stop = inView(element.parentElement ?? element, () => {
    animation.play();
  });
};

export const animateCampaign = (blocks: NodeListOf<HTMLElement>) => {
  // Animate when scrolled into view
  if (!prefersReducedMotion()) {
    blocks.forEach(block => {
      const content = block.querySelector<HTMLElement>(".rotate-in-from-right");
      const picture = block.querySelector<HTMLElement>(".rotate-in-from-left");

      let remaining = (content ? 1 : 0) + (picture ? 1 : 0);

      if (remaining > 0) {
        // The elements wait and animate outside the edges of the block. Without clipping, the page
        // can be scrolled sideways to them, which html having overflow-x hidden does not prevent on mobile.
        // Clip is used instead of hidden, as it does not make the block a scroll container.
        block.style.overflowX = "clip";

        const onDone = () => {
          remaining--;

          if (remaining === 0) {
            block.style.removeProperty("overflow-x");
          }
        };

        if (content) {
          animateInWhenVisible(content, rotateInFromRight, onDone);
        }

        if (picture) {
          animateInWhenVisible(picture, rotateInFromLeft, onDone);
        }
      }
    });
  }
};
